module.exports = __webpack_public_path__ + "static/media/lyft.ec98d6bf.png";